import { Navigate } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../providers/AuthProvider';
import ReviewMonitoringService from '../../services/ReviewMonitoringService';

const IndexRedirect = () => {
  const { hasRole } = useContext(AuthContext);
  const [redirectPath, setRedirectPath] = useState<string | null>(null);

  useEffect(() => {
    const controller = new AbortController();

    const loadMonitorings = async () => {
      const data = await ReviewMonitoringService.getMonitoring(
        true,
        'both',
        () => {},
        controller.signal
      );

      if (!Array.isArray(data) || data.length === 0) {
        setRedirectPath('/monitoring/platforms');
        return;
      }

      setRedirectPath(hasRole('can-use-dashboard') ? '/dashboard' : '/monitoring/platforms');
    };

    void loadMonitorings();

    return () => {
      controller.abort();
    };
  }, [hasRole]);

  if (!redirectPath) return null;

  return (
    <Navigate
      replace
      to={redirectPath}
    />
  );
};

export default IndexRedirect;
